
import React, { useContext, useEffect, useMemo, useState, useRef } from 'react'
import { SpinnerComponent } from 'react-element-spinner'
import {
	Button,
	Card,
	CardBody,
	CardFooter,
	CardHeader,
	CardTitle,
	Col,
	Collapse,
	Container,
	FormGroup,
	Input,
	Label,
	ListGroup,
	ListGroupItem,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Row
} from 'reactstrap'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { AuctionsContext } from '../../../../contexts/AuctionsProvider'
import { SessionContext } from '../../../../contexts/SessionProvider'
import AuctionsService from '../../../../services/AuctionsService'
import SiteService from '../../../../services/SiteService'
import {subscribe, trigger, unsubscribe} from '../../../../events/customEvents'
import RestartAuctionModal from '../../../../components/Modals/RestartAuctionModal'
import Enumeration from '../../../../enumeration'
import VehicleInspectionsService from '../../../../services/VehicleInspectionsService'
import EmailTemplatesService from '../../../../services/EmailTemplatesService'
import SelectExternalUserModalRedux from '../../../../components/Modals/SelectExternalUserModalRedux'
import SelectDealerUserModalRedux from '../../../../components/Modals/SelectDealerUserModalRedux'
import PageTitleContextMenu from '../../../../components/PageTitles/PageTitleContextMenu'
import AuctionsNavBar from '../../../../components/Navbars/AuctionsNavBar'

const AuctionDetail = ({ embedded = false, onRequestClose, onSelectDetailTab }) =>
{
	const { t } = useTranslation()
	const auctionsContext = useContext(AuctionsContext)
	const sessionContext = useContext(SessionContext)
	const [isBusy, setIsBusy] = useState(false)
	const [openedTierCollapse, setOpenedTierCollapse] = useState([])
	const [auctionTierMembers, setAuctionTierMembers] = useState([])
	const [auctionSubmitted, setAuctionSubmitted] = useState(false)
	const [auctionTierStates, setAuctionTierStates] = useState([
		{ auctionTierStateId: 1, name: 'New' },
		{ auctionTierStateId: 2, name: 'Pending' },
		{ auctionTierStateId: 3, name: 'Active' },
		{ auctionTierStateId: 4, name: 'Inactive' },
		{ auctionTierStateId: 5, name: 'Cancelled' }
	])
	const [activeTier, setActiveTier] = useState(undefined)
	const [activeTierMembers, setActiveTierMembers] = useState(undefined)
	const [showRestartAuctionModal, setShowRestartAuctionModal] = useState(false)
	const [exclusionList, setExclusionList] = useState([])
	const [showExternalUserModal, setShowExternalUserModal] = useState(false)
	const [showDealerUserModal, setShowDealerUserModal] = useState(false)
	const navigate = useNavigate()
	const [openConfirmDeleteTierMember, setOpenConfirmDeleteTierMember] = useState(false)
	const [selectedTierMemberId, setSelectedTierMemberId] = useState(undefined)
	const [emailTemplates, setEmailTemplates] = useState([])
	const [openConfirmCancelAuctionModal, setOpenConfirmCancelAuctionModal] = useState(false)
	
	let openTabIndex = 0
	
	useEffect(() =>
	{
		initializeComponent()
		
		subscribe('selectExternalUserModalClosed', handleSelectExternalUserModalClosed)
		subscribe('selectDealerUserModalClosed', handleSelectDealerUserModalClosed)
	}, [])
	
	useEffect(() =>
	{
		return () =>
		{
			unsubscribe('selectExternalUserModalClosed', handleSelectExternalUserModalClosed)
			unsubscribe('selectDealerUserModalClosed', handleSelectDealerUserModalClosed)
		}
	}, [])
	
	const initializeComponent = () =>
	{
		if (auctionsContext.auction.auctionId !== undefined)
		{
			convertAuctionTimesToLocal()
			retrieveAuctionTiers()
		}
		initializeValidation()
		retrieveEmailTemplatesList()
	}
	
		const retrieveEmailTemplatesList = () =>
		{
			setIsBusy(true)
			EmailTemplatesService
				.getEmailTemplatesList(sessionContext.loginSession.user.userSession.sessionKey)
				.then(result =>
				{
					setIsBusy(false)
					sessionContext.updateSession(result.data.loginSession)
	
					const _emailTemplates = []
					_emailTemplates.push({ emailTemplateId: null, templateName: '-- Select --' })
					result.data.actionResult.map((emailTemplate) =>
					{
						_emailTemplates.push(emailTemplate)
					})
					setEmailTemplates(_emailTemplates)
				})
				.catch((error) =>
				{
					setIsBusy(false)
					SiteService.displayApiError(error)
				})
		}
	
		const initializeValidation = () =>
		{
			auctionsContext.setAuction((previousAuction) =>
			{
				const _validation =
				{
					validation: { auctionLocalStartTime: false }
				}
	
				let currentAuction = { ...previousAuction }
				currentAuction =
				{
					...currentAuction,
					..._validation
				}
				return currentAuction
			})
		}
	
		const convertAuctionTimesToLocal = () =>
		{
			auctionsContext.setAuction((previousAuction) =>
			{
				const currentAuction = { ...previousAuction }
				currentAuction.auctionLocalStartTime = currentAuction.auctionUtcStartTime != null
					? convertUtcToLocal(currentAuction.auctionUtcStartTime)
					: undefined
				currentAuction.auctionLocalEndTime = currentAuction.auctionUtcEndTime != null
					? convertUtcToLocal(currentAuction.auctionUtcEndTime)
					: undefined
				return currentAuction
			})
		}
	
		const convertUtcToLocal = (utcTime) =>
		{
			utcTime = utcTime.replace('T', ' ').replace('+00:00', ' GMT')
			const localDate = new Date(utcTime)
			
			return localDate.getFullYear() + '-' +
				('0' + (localDate.getMonth() + 1)).slice(-2) + '-' +
				('0' + localDate.getDate()).slice(-2) + 'T' +
				('0' + localDate.getHours()).slice(-2) + ':' +
				('0' + localDate.getMinutes()).slice(-2) + ':' +
				('0' + localDate.getSeconds()).slice(-2)
		}
	
		const retrieveAuctionTiers = () =>
		{
			setIsBusy(true)
			AuctionsService
				.getAuctionTiers(auctionsContext.auction.auctionId, sessionContext.loginSession.user.userSession.sessionKey)
				.then(result =>
				{
					setIsBusy(false)
					sessionContext.updateSession(result.data.loginSession)
	
					auctionsContext.setAuction((previousAuction) =>
					{
						const currentAuction = { ...previousAuction }
						currentAuction.auctionTiers = result.data.actionResult
	
						let _auctionTiers = []
						currentAuction.auctionTiers.forEach((auctionTier) =>
						{
							auctionTier.tierLocalStartTime = (auctionTier.tierUtcStartTime) != null ? convertUtcToLocal(auctionTier.tierUtcStartTime) : undefined
							auctionTier.tierLocalEndTime = (auctionTier.tierUtcEndTime) != null ? convertUtcToLocal(auctionTier.tierUtcEndTime) : undefined
							const _tierValidation = { validation: { name: false, activeDurationHours: false } }
							_auctionTiers.push({
								...auctionTier,
								..._tierValidation
							})
						})
						currentAuction.auctionTiers = _auctionTiers
	
						return currentAuction
					})
				})
				.catch((error) =>
				{
					setIsBusy(false)
					SiteService.displayApiError(error)
				})
		}
	
	const toggleTierCollapse = (tierIndexPosition) =>
	{
		if (openedTierCollapse.includes(tierIndexPosition))
		{
			setOpenedTierCollapse([])
			setActiveTier(undefined)
			setActiveTierMembers(undefined)
		}
		else
		{
			setOpenedTierCollapse([tierIndexPosition])
			
			const auctionTier = auctionsContext.auction.auctionTiers.find(tier => { return tier.tierIndexPosition === tierIndexPosition })
			setActiveTier(auctionTier)
			setActiveTierMembers(auctionTier.auctionTierMembers)
		}
	}
	
/*	const retrieveAuctionTierMembers = (auctionTierId, userGroupId, parentEntityId) =>
	{
		setIsBusy(true)
		AuctionsService
			.getAuctionTierMembers(auctionTierId, userGroupId, parentEntityId, sessionContext.loginSession.user.userSession.sessionKey)
			.then(result =>
			{
				setIsBusy(false)
				sessionContext.updateSession(result.data.loginSession)
				
				setAuctionTierMembers(result.data.actionResult)
			})
			.catch((error) =>
			{
				setIsBusy(false)
				SiteService.displayApiError(error)
			})
	}*/
	
	const handleAuctionStateChange = (option) =>
	{
		handleAuctionPropertyChange(option)
	}
	
	const handleAuctionTimeChange = (option) =>
	{
		const { name, value} = option.target
		const utcTimeName = (name === 'auctionLocalStartTime') ? 'auctionUtcStartTime' : 'auctionUtcEndTime'
		
		let date = new Date(value)
		
		auctionsContext.setAuction((previousAuction) =>
		{
			const currentAuction = { ...previousAuction }
			currentAuction[name] = value
			currentAuction[utcTimeName] = date.toUTCString()
			return currentAuction
		})
	}
	
	const handleAuctionPropertyChange = (e) =>
	{
		const { name, value} = e.target
		auctionsContext.setAuction((previousAuction) =>
		{
			const currentAuction = { ...previousAuction }
			currentAuction[name] = value
			return currentAuction
		})
	}
	
	const isValidAuction = () =>
	{
		let auctionClone = { ...auctionsContext.auction }
		let auctionValid = auctionClone.validation.auctionLocalStartTime = (new Date(auctionClone.auctionLocalStartTime) instanceof Date)
		
		if (auctionClone.auctionTiers && auctionClone.auctionTiers.length > 0)
		{
			auctionClone.auctionTiers = auctionClone.auctionTiers.map((tier) =>
			{
				const tierClone = { ...tier, validation: { ...tier.validation } }
				tierClone.validation.name = tierClone.name !== undefined && tierClone.name !== null && tierClone.name.trim() !== ''
				tierClone.validation.activeDurationHours = tierClone.activeDurationHours !== undefined && tierClone.activeDurationHours !== null && Number(tierClone.activeDurationHours) > 0
				
				if (!tierClone.validation.name || !tierClone.validation.activeDurationHours)
				{
					auctionValid = false
				}
				
				return tierClone
			})
		}
		
		auctionsContext.setAuction(auctionClone)
		
		return auctionValid
	}
	
	const handleUpdateAuction = (e) =>
	{
		e.preventDefault()
		
		setAuctionSubmitted(true)
		if (isValidAuction())
		{
			setIsBusy(true)
			AuctionsService
				.updateAuction(auctionsContext.auction, sessionContext.loginSession.user.userSession.sessionKey)
				.then(result =>
				{
					setIsBusy(false)
					setAuctionSubmitted(false)
					sessionContext.updateSession(result.data.loginSession)
					
					trigger('raiseNotification', { title: 'Update Success', message: 'The auction was updated.', type: 'success', duration: 5 })
					navigate('/secure/auctions-listing')
				})
				.catch((error) =>
				{
					setIsBusy(false)
					SiteService.displayApiError(error)
				})
		}
		else
		{
			setAuctionSubmitted(false)
			SiteService.displayApiError({ message: 'Invalid input. The auction input is invalid.' })
		}
	}
	
	const handleCancelAuction = () =>
	{
		let currentAuction = auctionsContext.auction
		currentAuction.auctionStateId = Enumeration.AuctionStates.Cancelled
		
		setIsBusy(true)
		AuctionsService
			.cancelAuction(currentAuction, sessionContext.loginSession.user.userSession.sessionKey)
			.then(result =>
			{
				setIsBusy(false)
				setOpenConfirmCancelAuctionModal(false)
				sessionContext.updateSession(result.data.loginSession)
				
				trigger('raiseNotification', { title: 'Cancel Success', message: 'The auction was cancelled.', type: 'success', duration: 5 })
				navigate('/secure/auctions-listing')
			})
			.catch((error) =>
			{
				setIsBusy(false)
				SiteService.displayApiError(error)
			})
	}
	
	const expireAuctionTier = () =>
	{
		let auctionTierId = 0;
		
		if (!activeTier)
		{
			auctionsContext.auction.auctionTiers.forEach((auctionTier) =>
			{
				if (auctionTier.auctionTierStateId === Enumeration.AuctionTierStates.Active)
				{
					auctionTierId = auctionTier.auctionTierId
				}
			})
		}
		else
		{
			auctionTierId = activeTier.auctionTierId
		}
		
		if (auctionTierId > 0)
		{
			setIsBusy(true)
			AuctionsService
				.expireAuctionTier(auctionTierId, sessionContext.loginSession.user.userSession.sessionKey)
				.then(result =>
				{
					setIsBusy(false)
					sessionContext.updateSession(result.data.loginSession)
					
					trigger('raiseNotification', {
						title: 'Success',
						message: 'The auction tier has been ended.',
						type: 'success',
						duration: 5
					})
					navigate('/secure/auctions-listing')
				})
				.catch((error) =>
				{
					setIsBusy(false)
					SiteService.displayApiError(error)
				})
		}
		else
		{
			trigger('raiseNotification', { title: 'Error', message: 'Cannot find an active auction tier', type: 'danger', duration: 5 })
		}
	}
	
	const handleStartNextTier = () =>
	{
		let nextAuctionTierId = 0
		
		for (let a = 0; a < auctionsContext.auction.auctionTiers.length; a++)
		{
			if (auctionsContext.auction.auctionTiers[a].auctionTierId === activeTier.auctionTierId)
			{
				try
				{
					nextAuctionTierId = auctionsContext.auction.auctionTiers[a + 1].auctionTierId
					break
				}
				catch {}
			}
		}
		
		if (nextAuctionTierId > 0)
		{
			setIsBusy(true)
			AuctionsService
				.startAuctionTier(auctionsContext.auction.auctionId, nextAuctionTierId, sessionContext.loginSession.user.userSession.sessionKey)
				.then(result =>
				{
					setIsBusy(false)
					sessionContext.updateSession(result.data.loginSession)
					
					trigger('raiseNotification', { title: 'Success', message: 'The next auction tier has been started.', type: 'success', duration: 5 })
					navigate('/secure/auctions-listing')
				})
				.catch((error) =>
				{
					setIsBusy(false)
					SiteService.displayApiError(error)
				})
		}
		else
		{
			trigger('raiseNotification', { title: 'Error', message: 'There does not appear to be a next auction tier', type: 'danger', duration: 5 })
		}
	}
	
	const handleStartAuction = () =>
	{
		setIsBusy(true)
		AuctionsService
			.startAuction(auctionsContext.auction.auctionId, sessionContext.loginSession.user.userSession.sessionKey)
			.then(result =>
			{
				setIsBusy(false)
				sessionContext.updateSession(result.data.loginSession)
				
				trigger('raiseNotification', { title: 'Success', message: 'The auction has been started.', type: 'success', duration: 5 })
				navigate('/secure/auctions-listing')
			})
			.catch((error) =>
			{
				setIsBusy(false)
				SiteService.displayApiError(error)
			})
	}
	
	const handleCreateNewTier = () =>
	{
		let nextAuctionTierId = 1
		
		if (auctionsContext.auction.auctionTiers.length > 0)
		{
			const auctionTier = auctionsContext.auction.auctionTiers.reduce((prev, current) => (prev && prev.auctionTierId > current.auctionTierId) ? prev : current)
			nextAuctionTierId = auctionTier.auctionTierId + 1
		}
		
		auctionsContext.setAuction((previousAuction) =>
		{
			const currentAuction = { ...previousAuction }
			
			const newAuctionTier =
				{
					auctionTierId: nextAuctionTierId,
					auctionId: currentAuction.auctionId,
					name: 'New Auction Tier',
					tierIndexPosition: currentAuction.auctionTiers.length,
					auctionTierTypeId: Enumeration.AuctionTierTypes.BiddingTier,
					activeDurationHours: 0,
					auctionTierStateId: Enumeration.AuctionTierStates.New,
					auctionTierMembers: [],
					emailTemplateId: 0,
					isNew: true,
					validation: { name: false, activeDurationHours: false }
				}
			currentAuction.auctionTiers.push(newAuctionTier)
			
			setOpenedTierCollapse([newAuctionTier.tierIndexPosition])
			setActiveTier(newAuctionTier)
			setActiveTierMembers(newAuctionTier.auctionTierMembers)
			
			return currentAuction
		})
	}
	
	const handleAuctionTierPropertyChange = (e, auctionTierId) =>
	{
		const { name, value} = e.target
		auctionsContext.setAuction((previousAuction) =>
		{
			const currentAuction = { ...previousAuction }
			const auctionTier = currentAuction.auctionTiers.find((auctionTier) => auctionTier.auctionTierId === auctionTierId)
			auctionTier[name] = value
			return currentAuction
		})
	}
	
	const handleAddExternalUser = () =>
	{
		const exclusionList = []
		auctionsContext.auction.auctionTiers.forEach((auctionTier) =>
		{
			auctionTier.auctionTierMembers.forEach((tierMember) =>
			{
				exclusionList.push(tierMember.entityId)
			})
		})
		
		setExclusionList((previousExclusionList) =>
		{
			setShowExternalUserModal(true)
			return exclusionList
		})
	}
	
	const handleAddDealerUser = () =>
	{
		const exclusionList = []
		auctionsContext.auction.auctionTiers.forEach((auctionTier) =>
		{
			if (activeTier.auctionTierId === auctionTier.auctionTierId)
			{
				auctionTier.auctionTierMembers.forEach((tierMember) =>
				{
					exclusionList.push(tierMember.entityId)
				})
			}
		})
		
		setExclusionList((previousExclusionList) =>
		{
			setShowDealerUserModal(true)
			return exclusionList
		})
	}
	
	const confirmRemoveTierMember = (auctionTierMemberId) =>
	{
		setSelectedTierMemberId((previousSelectedTierMemberId) =>
		{
			setOpenConfirmDeleteTierMember(true)
			return auctionTierMemberId
		})
	}
	
	const handleRemoveTierMember = () =>
	{
		setOpenConfirmDeleteTierMember(false)
		setIsBusy(true)
		AuctionsService
			.removeTierMember(selectedTierMemberId, sessionContext.loginSession.user.userSession.sessionKey)
			.then(result =>
			{
				setIsBusy(false)
				sessionContext.updateSession(result.data.loginSession)
				
				trigger('raiseNotification', { title: 'Success', message: 'The auction tier member has been removed.', type: 'success', duration: 5 })
				navigate('/secure/auctions-listing')
			})
			.catch((error) =>
			{
				setIsBusy(false)
				SiteService.displayApiError(error)
			})
	}
	
	const handleRestartAuction = () =>
	{
		setShowRestartAuctionModal(true)
	}
	
	const restartAuctionModalClosed = (event) =>
	{
		setShowRestartAuctionModal(false)
		initializeComponent()
	}
	
	const handleSelectDealerUserModalClosed = (event) =>
	{
		setShowDealerUserModal(false)
		handleUpdateTierMembers({...event.detail})
	}
	
	const handleSelectExternalUserModalClosed = (event) =>
	{
		setShowExternalUserModal(false)
		handleUpdateTierMembers({...event.detail})
	}
	
	const handleUpdateTierMembers = (eventDetail) =>
	{
		setActiveTierMembers(([...eventDetail.activeTierMembers]))
		
		auctionsContext.setAuction((previousAuction) =>
		{
			const currentAuction = { ...previousAuction }
			
			const auctionTier = currentAuction.auctionTiers.find((auctionTier) => { return auctionTier.auctionTierId === eventDetail.tierId })
			auctionTier.auctionTierMembers = [ ...eventDetail.activeTierMembers ]
			
			for (let t = 0; t < currentAuction.auctionTiers.length; t++)
			{
				if (currentAuction.auctionTiers[t].auctionTierId === auctionTier.auctionTierId)
				{
					currentAuction.auctionTiers[t] = auctionTier
					break
				}
			}
			
			return currentAuction
		})
	}
	
	const handleGetVehicleInspection = (serialNumber) =>
	{
		setIsBusy(true)
		VehicleInspectionsService
			.downloadVehicleInspection(serialNumber, sessionContext.loginSession.user.userSession.sessionKey)
			.then(result =>
			{
				setIsBusy(false)
				sessionContext.updateSession(result.data.loginSession)
				
				trigger('raiseNotification', {
					title: 'Vehicle Inspection Requested',
					message: 'The vehicle inspection has been requested. Check back later.',
					type: 'success',
					duration: 5
				})
			})
			.catch((error) =>
			{
				setIsBusy(false)
				SiteService.displayApiError(error)
			})
	}
	
	const handleReleaseInspection = () =>
	{
		const auction = auctionsContext.auction
		auction.auctionStateId = Enumeration.AuctionStates.Released
		
		setAuctionSubmitted(true)
		
		if (isValidAuction())
		{
			setIsBusy(true)
			AuctionsService
				.releaseAuction(auctionsContext.auction.auctionId, sessionContext.loginSession.user.userSession.sessionKey)
				.then(result =>
				{
					setIsBusy(false)
					setAuctionSubmitted(false)
					sessionContext.updateSession(result.data.loginSession)
					
					if (result.data.actionResult)
					{
						trigger('raiseNotification', { title: 'Update Success', message: 'The auction was released.', type: 'success', duration: 5 })
					}
					else
					{
						trigger('raiseNotification', { title: 'Update Error', message: 'Something went wrong. The auction was not released.', type: 'danger', duration: 5 })
					}
					
					navigate('/secure/auctions-search')
				})
				.catch((error) =>
				{
					setIsBusy(false)
					SiteService.displayApiError(error)
				})
		}
		else
		{
			setAuctionSubmitted(false)
			SiteService.displayApiError({ message: 'Invalid input. The auction input is invalid.' })
		}
	}
	
	const auctionTierStateLabel = (auctionTierStateId) =>
	{
		let auctionTierStateName = 'New'
		if (auctionTierStateId)
		{
			auctionTierStateName = auctionTierStates.find((ats) => ats.auctionTierStateId === auctionTierStateId).name
		}
		return auctionTierStateName
	}
	
	const handleGoBack = () =>
	{
		if (embedded)
		{
			if (typeof onRequestClose === 'function') onRequestClose()
			return
		}
		navigate('/secure/auctions-listing')
	}
	
	return (
		<div style={{
			zIndex: 500
		}}>
			<SpinnerComponent
				loading={ isBusy }
				position="global"
				color="#3578e5"
				secondaryColor="#f3f3f3"
				backgroundColor="#d3d3d3"
				spinnerType="circle-dots"
			/>
			{ !embedded && (
				<PageTitleContextMenu
					heading={ t('Auctions.Detail.Title') }
					subheading={ auctionsContext.auction.auctionVehicle.vehicle.year + ' ' +
						auctionsContext.auction.auctionVehicle.vehicle.make + ' ' +
						auctionsContext.auction.auctionVehicle.vehicle.model + ' / ' +
						auctionsContext.auction.auctionVehicle.vehicle.trim + ' / ' +
						auctionsContext.auction.auctionVehicle.vehicle.serialNumber
					}
					icon="pe-7s-ticket icon-gradient bg-premium-dark"
					headerOptions={ { showBack: true, backCommand: () => { handleGoBack() }, showReload: false, reloadCommand: null } }
				/>
			) }
			<Container className={ embedded ? undefined : 'mt--6' } fluid>
				<Row>
					<div className="col">
						<Card>
							<CardHeader	>
								<AuctionsNavBar
									parentComponent={'auction-detail'}
									onSelect={ embedded ? onSelectDetailTab : undefined }
								/>
							</CardHeader>
							<CardBody>
								<Row>
									<Col md="6">
										<FormGroup>
											<Label>{ t('Auctions.Detail.StartTime') }</Label>
											<Input
												disabled
												type="datetime-local"
												name="auctionLocalStartTime"
												value={ auctionsContext.auction.auctionLocalStartTime }
												onChange={ handleAuctionTimeChange }
											/>
										</FormGroup>
									</Col>
									<Col md="6">
										<FormGroup>
											<Label>{ t('Auctions.Detail.AuctionState') }</Label>
											<Input
												disabled
												className="form-control-sm"
												type="select"
												name="auctionStateId"
												onChange={ handleAuctionStateChange }
												value={ auctionsContext.auction.auctionStateId }
											>
												<option value="">All</option>
												<option value="1">Grounded</option>
												<option value="2">AwaitingInspection</option>
												<option value="3">AwaitingPricing</option>
												<option value="4">AwaitingRelease</option>
												<option value="5">Released</option>
												<option value="6">InSettlement</option>
												<option value="7">Sold</option>
												<option value="8">CompleteUnsold</option>
												<option value="9">Expired</option>
											</Input>
										</FormGroup>
									</Col>
								</Row>
								<Row>
									<Col md="6">
										<FormGroup>
											<Label>{ t('Auctions.Detail.EndTime') }</Label>
											<Input
												disabled
												type="datetime-local"
												name={"auctionLocalEndTime"}
												value={ auctionsContext.auction.auctionLocalEndTime }
												onChange={ handleAuctionTimeChange }
											/>
										</FormGroup>
									</Col>
									{
										sessionContext.showAdminTestingControls &&
										<Col md="6" className="d-flex flex-column justify-content-end">
											<FormGroup className="d-flex gap-2 justify-content-end">
												<Button
													color="warning"
													size="sm"
													onClick={ () => handleStartAuction() }
												>
													{ t('Auctions.Detail.Testing.Start_Auction') }
												</Button>
												<Button
													color="warning"
													size="sm"
													onClick={ () => expireAuctionTier() }
												>
													{ t('Auctions.Detail.Testing.End_Auction') }
												</Button>
											</FormGroup>
										</Col>
									}
								</Row>
								<Row><Col md="12"><hr /></Col></Row>
								<Row>
									<Col md="6">
										<Row style={{ paddingBottom: '2px' }}>
											<Col md="6">
												<Label>{ t('Templates.AuctionDetail.Tiers_Header') }</Label>
											</Col>
											<Col md="6">
												<div className="text-right" hidden={ true }>
													{
														auctionsContext.auction.auctionStateId !== Enumeration.AuctionStates.Released &&
														<Button color="default" size="sm" type="button" onClick={ () => handleCreateNewTier() }>
															{ t('Templates.AuctionDetail.Tiers.Create_New') }
														</Button>
													}
												</div>
											</Col>
										</Row>
										<Row>
											<Col md="12">
												<div className="tier-group">
													<div className="accordion">
														{
															auctionsContext.auction.auctionTiers !== undefined &&
															auctionsContext.auction.auctionTiers.map((auctionTier) => (
																<Card
																	className="card-plain"
																	key={ auctionTier.tierIndexPosition }
																>
																	<CardHeader
																		role="tab"
																		onClick={() => toggleTierCollapse(auctionTier.tierIndexPosition)}
																		aria-expanded={openedTierCollapse.includes(
																			auctionTier.tierIndexPosition
																		)}
																	>
																		<Label style={{ cursor: 'pointer' }}>{ auctionTier.name + ' (' + auctionTierStateLabel(auctionTier.auctionTierStateId) + ')' }</Label>
																	</CardHeader>
																	<Collapse
																		role="tabpanel"
																		isOpen={openedTierCollapse.includes(auctionTier.tierIndexPosition)}
																	>
																		<CardBody>
																			<FormGroup>
																				<Label>{ t('Templates.AuctionDetail.Tiers.Tier_Name') }</Label>
																				<Input
																					className="form-control-sm"
																					type="text"
																					name="name"
																					value={ auctionTier.name }
																					onChange={
																						(ev) =>
																					{
																						handleAuctionTierPropertyChange(ev, auctionTier.auctionTierId)
																					}
																					}
																					valid={ auctionSubmitted && auctionTier.validation.name }
																					invalid={ auctionSubmitted && !auctionTier.validation.name  }
																				/>
																			</FormGroup>
																			<FormGroup>
																				<Label>{ t('Auctions.Detail.StartTime') }</Label>
																				<Input
																					disabled
																					type="datetime-local"
																					name="auctionTierLocalStartTime"
																					value={ auctionTier.tierLocalStartTime }
																				/>
																			</FormGroup>
																			<FormGroup>
																				<Label>{ t('Auctions.Detail.EndTime') }</Label>
																				<Input
																					disabled
																					type="datetime-local"
																					name="auctionTierLocalEndTime"
																					value={ auctionTier.tierLocalEndTime }
																				/>
																			</FormGroup>
																			<FormGroup>
																				<Label>{ t('Templates.AuctionDetail.Tiers.Active_Duration_Hours') }</Label>
																				<Input
																					disabled
																					className="form-control-sm"
																					type="text"
																					name="activeDurationHours"
																					value={ auctionTier.activeDurationHours }
																					onChange={
																						(ev) =>
																						{
																							handleAuctionTierPropertyChange(ev, auctionTier.auctionTierId)
																						}
																					}
																					valid={ auctionSubmitted && auctionTier.validation.activeDurationHours }
																					invalid={ auctionSubmitted && !auctionTier.validation.activeDurationHours  }
																				/>
																			</FormGroup>
																			<FormGroup>
																				<Label>{ t('Templates.AuctionDetail.Tiers.Tier_State') }</Label>
																				<Input
																					type="select"
																					name="auctionTierStateId"
																					value={ auctionTier.auctionTierStateId }
																					onChange={
																						(ev) =>
																						{
																							handleAuctionTierPropertyChange(ev, auctionTier.auctionTierId)
																						}
																					}
																					disabled={ true }
																				>
																					{
																						auctionTierStates !== undefined &&
																						auctionTierStates.map((auctionTierState, idx) => (
																							<option value={ auctionTierState.auctionTierStateId } key={ idx }>
																								{ auctionTierState.name }
																							</option>
																						))
																					}
																				</Input>
																			</FormGroup>
																			<FormGroup>
																				<Label>{ t('Templates.AuctionDetail.Tiers.Email_Template') }</Label>
																				<Input
																					type="select"
																					name="emailTemplateId"
																					value={ auctionTier.emailTemplateId }
																					onChange={
																						(ev) =>
																						{
																							handleAuctionTierPropertyChange(ev, auctionTier.auctionTierId)
																						}
																					}
																				>
																					{
																						emailTemplates !== undefined &&
																						emailTemplates.map((emailTemplate, idx) => (
																							<option value={ emailTemplate.emailTemplateId } key={ idx }>
																								{ emailTemplate.templateName }
																							</option>
																						))
																					}
																				</Input>
																			</FormGroup>
																			<Row>
																				<Col md="12">
																					<FormGroup className="d-flex gap-2 justify-content-end">
																						{
																							(sessionContext.showAdminTestingControls && (auctionTier.auctionTierStateId === Enumeration.AuctionTierStates.Active)) && (
																								<Button
																									color="warning"
																									size="sm"
																									onClick={ () => expireAuctionTier() }
																								>
																									{ t('Auctions.Detail.Testing.End_Auction_Tier') }
																								</Button>
																							)
																						}
																					</FormGroup>
																				</Col>
																			</Row>
																		</CardBody>
																	</Collapse>
																</Card>
															))
														}
													</div>
												</div>
											</Col>
										</Row>
									</Col>
									<Col md="6">
										<Row style={{ paddingBottom: '2px' }}>
											<Col md="6">
												<Label>{ t('Auctions.Detail.Bidders_Header') }</Label>
											</Col>
											<Col md="6"></Col>
										</Row>
										<Row>
											<Col md="12">
												<div className="tier-group">
													{
														(activeTierMembers !== undefined) ? (
															<>
																<Row style={{ paddingBottom: '2px' }}>
																	<Col md="12">
																		<div className="text-right">
																			<Button
																				color="secondary"
																				size="sm"
																				onClick={ () => handleAddExternalUser() }
																				style={{ marginLeft: '5px' }}
																			>
																				{ t('Auctions.Detail.Tiers.Members.Add_External_User') }
																			</Button>
																			<Button
																				color="secondary"
																				size="sm"
																				onClick={ () => handleAddDealerUser() }
																				style={{ marginLeft: '5px' }}
																			>
																				{ t('Auctions.Detail.Tiers.Members.Add_Dealer_User') }
																			</Button>
																		</div>
																	</Col>
																</Row>
																<Row>
																	<Col md="12">
																		<CardBody style={{ paddingLeft: '0px', paddingRight: '0px' }}>
																			{activeTierMembers.map((activeTierMember, idx) => (
																				<ListGroup key={ idx } className="mt-3" flush>
																					<ListGroupItem className="px-0" style={{ padding: '0px' }}>
																						<Row className="align-items-center">
																							<Col className="col-auto">
																								<Button color="danger" size="sm" onClick={ () => confirmRemoveTierMember(activeTierMember.tierMemberId) }>
																									{ t('Auctions.Detail.Tiers.Members.Remove_Member') }
																								</Button>
																							</Col>
																							<div className="col ml--2">
																								<h5 className="mb-0">{ activeTierMember.fullName }</h5>
																							</div>
																							<Col className="col-auto">
																								<h5 className="checklist-title mb-0">{ activeTierMember.dealerName + ' - ' + activeTierMember.oemName }</h5>
																							</Col>
																						</Row>
																					</ListGroupItem>
																				</ListGroup>
																			))}
																		</CardBody>
																	</Col>
																</Row>
															</>
														) : (
															<Label className="form-control-label" >{ t('Auctions.Detail.Tiers.Members.Select_Auction_Tier') }</Label>
														)
													}
												</div>
											</Col>
										</Row>
									</Col>
								</Row>
								<Row>
									<Col md="6">
										<Button block color="warning" className="btn-block" onClick={ () => setOpenConfirmCancelAuctionModal(true) } style={{'marginTop': '30px'}}>
											{'Cancel Auction'}
										</Button>
									</Col>
									<Col md="6">
										<Button block color="primary" className="btn-block" onClick={ handleUpdateAuction } style={{'marginTop': '30px'}}>
											{t('Common.Update')}
										</Button>
									</Col>
								</Row>
							</CardBody>
							<CardFooter></CardFooter>
						</Card>
					</div>
				</Row>
			</Container>
			
			<RestartAuctionModal
				showRestartAuctionModal={ showRestartAuctionModal }
				auctionId={ auctionsContext.auction.auctionId }
			/>
			
			<SelectExternalUserModalRedux
				showExternalUserModal={ showExternalUserModal }
				exclusionList={ exclusionList }
				activeTierMembers={ activeTierMembers }
				tierId={ (activeTier !== undefined) ? activeTier.auctionTierId : 0 }
			/>
			
			<SelectDealerUserModalRedux
				showDealerUserModal={ showDealerUserModal }
				exclusionList={ exclusionList }
				activeTierMembers={ activeTierMembers }
				tierId={ (activeTier !== undefined) ? activeTier.auctionTierId : 0 }
			>
			</SelectDealerUserModalRedux>

			<Modal
				isOpen={ openConfirmDeleteTierMember }
				toggle={ () => setOpenConfirmDeleteTierMember(false) }
			>
				<ModalHeader toggle={ () => setOpenConfirmDeleteTierMember(false) } charCode="Y">
					{ t('Auctions.Detail.Delete_Tier_Member') }
				</ModalHeader>
				<ModalBody>
					<Card >
						<CardBody>
							<div className="modal-body"><p>{t('Auctions.Detail.Confirm_Delete_Member_Message')}</p></div>
						</CardBody>
					</Card>
				</ModalBody>
				<ModalFooter>
					<Row style={{ width: '100%' }}>
						<Col md={6}>
							<Button
								block
								color="secondary"
								className="btn-block"
								onClick={ () => setOpenConfirmDeleteTierMember(false) }
							>
								{ t('Common.No') }
							</Button>
						</Col>
						<Col md={6}>
							<Button
								block
								color="primary"
								className="btn-block"
								onClick={ handleRemoveTierMember }
							>
								{ t('Common.Yes') }
							</Button>
						</Col>
					</Row>
				</ModalFooter>
			</Modal>

			<Modal
				isOpen={ openConfirmCancelAuctionModal }
				toggle={ () => setOpenConfirmCancelAuctionModal(false) }
			>
				<ModalHeader toggle={ () => setOpenConfirmCancelAuctionModal(false) } charCode="Y">
					{ t('Auctions.Detail.Confirm_Cancel_Auction_Title') }
				</ModalHeader>
				<ModalBody>
					<Card>
						<CardBody>
							<div className="modal-body"><p>{t('Auctions.Detail.Confirm_Cancel_Auction_Message')}</p></div>
						</CardBody>
					</Card>
				</ModalBody>
				<ModalFooter>
					<Row style={{ width: '100%' }}>
						<Col md={6}>
							<Button
								block
								color="secondary"
								className="btn-block"
								onClick={ () => setOpenConfirmCancelAuctionModal(false) }
							>
								{ t('Common.No') }
							</Button>
						</Col>
						<Col md={6}>
							<Button
								block
								color="primary"
								className="btn-block"
								onClick={ handleCancelAuction }
							>
								{ t('Common.Yes') }
							</Button>
						</Col>
					</Row>
				</ModalFooter>
			</Modal>
		</div>
	)
}

export default AuctionDetail
